import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class VerificationPresenter extends EntityPresenter {
  static urn = 'verifications'
  static key = 'verification'

  static navOptions(key = 'verifications') {
    const routes = {
      verifications: {
        icon: 'new_releases',
        pageRoutes: ['verification'],
      },
    }
    return routes[key]
  }
}

bindPresenterMethods(VerificationPresenter)
